<template>
  <div>
    <div id="print">
      <div class="header">
        <span>票号：{{ ReprintData.ticketnumber }}</span>
        <span>建当日期：{{ ReprintData.deta }}</span>
      </div>
      <table width="100%">
        <tr>
          <td width="20%">当户</td>
          <td width="30%">{{ ReprintData.name }}</td>
          <td width="20%">电话</td>
          <td width="30%">{{ ReprintData.telnumber }}</td>
        </tr>
        <tr>
          <td width="20%">地址</td>
          <td>{{ ReprintData.address }}</td>
          <td width="20%">物品类型</td>
          <td>{{ ReprintData.itemname }}</td>
        </tr>
        <tr>
          <td>证件类型</td>
          <td>{{ ReprintData.type }}</td>
          <td>证件号码</td>
          <td>{{ ReprintData.cardnumber }}</td>
        </tr>
      </table>
      <table width="100%">
        <tr>
          <td>当物名称</td>
          <td>规格与状况</td>
          <td>数量</td>
          <td>重量/g</td>
          <td>上交所价格/元</td>
          <td>典当单价/元</td>
          <td>折当率/%</td>
          <td>典当金额/元</td>
        </tr>
        <tr>
          <td>{{ ReprintData.objname }}</td>
          <td>{{ ReprintData.speci }}</td>
          <td>{{ ReprintData.num || ReprintData.number }}</td>
          <td>{{ ReprintData.weig || ReprintData.weight }}</td>
          <td>{{ ReprintData.realpricea }}</td>
          <td>
            {{
              ReprintData.unitpricea !== "计算中..."
                ? ReprintData.unitpricea ||
                  (ReprintData.price / ReprintData.weight).toFixed(2)
                : "无"
            }}
          </td>
          <td>{{ ReprintData.rate || "未填写" }}</td>
          <td>{{ ReprintData.pric || ReprintData.price }}</td>
        </tr>
        <tr>
          <td>{{ ReprintData.objnamea }}</td>
          <td>{{ ReprintData.specia }}</td>
          <td>{{ ReprintData.numa }}</td>
          <td>{{ ReprintData.weiga }}</td>
          <td>{{ ReprintData.realpriceaa }}</td>
          <td>
            {{ ReprintData.unitpriceaa !== "计算中..." ? ReprintData.unitpriceaa : "" }}
          </td>
          <td>{{ ReprintData.ratea }}</td>
          <td>{{ ReprintData.prica }}</td>
        </tr>
        <tr>
          <td>{{ ReprintData.objnameaa }}</td>
          <td>{{ ReprintData.speciaa }}</td>
          <td>{{ ReprintData.numaa }}</td>
          <td>{{ ReprintData.weigaa }}</td>
          <td>{{ ReprintData.realpriceaaa }}</td>
          <td>
            {{ ReprintData.unitpriceaaa !== "计算中..." ? ReprintData.unitpriceaaa : "" }}
          </td>
          <td>{{ ReprintData.rateaa }}</td>
          <td>{{ ReprintData.pricaa }}</td>
        </tr>
      </table>
      <table width="100%">
        <tr>
          <td width="15%">开始日期</td>
          <td width="15%">{{ ReprintData.startdate }}</td>
          <td width="15%">到期日期</td>
          <td width="15%">{{ ReprintData.enddate }}</td>
          <td width="15%">典当天数</td>
          <td width="20%">{{ ReprintData.days }}</td>
        </tr>
      </table>
      <table width="100%">
        <tr>
          <td>数量：{{ ReprintData.number }}</td>
          <td>重量：{{ ReprintData.weight + "g" }}</td>
          <td>典当价格：{{ ReprintData.price + "元" }}</td>
          <td>典当综合费：{{ ReprintData.cost + "元" }}</td>
          <td>典当利息：{{ ReprintData.lx + "元" }}</td>
          <td>支付方式：</td>
        </tr>
      </table>
    </div>
    <div class="btn">
      <el-button type="primary" v-print="'#print'">打印</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "ReprintBill",
  props: ["ReprintData"],

  data() {
    return {};
  },

  mounted() {},
};
</script>
<style scoped>
table {
  border-collapse: collapse;
}
td {
  /* width: 100%; */
  height: 40px;
  border: 1px solid black;
  font-size: 15px;
  text-align: center;
}
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.btn {
  margin: 15px 0;
}
</style>
